var map = {
	"./blurmap-PROG-STANDARD_full_white.png": "8e4a",
	"./blurmap-VARILUX-COMFORT_full_white.png": "a969",
	"./blurmap-VARILUX-E-SERIES_full_white.png": "8507",
	"./blurmap-VARILUX-PHYSIO_full_white.png": "c5ff",
	"./blurmap-VARILUX-S-SERIES_full_white.png": "8825",
	"./blurmap-VARILUX-X-SERIES_full_white.png": "0b66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0b8";